import "../../../styles/modal.scss";

import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";

const mapStateToProps = state => {
    return {
        innerWidth: state.view.innerWidth
    };
};

class Modal extends React.PureComponent {
    constructor(props){
        super(props);
    }

    componentWillUnmount() {
        if (this.props.onComponentWillUnmount) {
            this.props.onComponentWillUnmount();
        }
    }

    render() {
        const {
            drawAboveMenu,
            width,
            children,
            onCloseModal,
            innerWidth,
        } = this.props;

        const modalWidth = Math.min( Math.max(320,innerWidth), width);

        if (this.props.hideCard) {
            return (
                <React.Fragment>
                    <div className="dim-screen" onClick={onCloseModal}/>
                    <div className={drawAboveMenu ? "modal above-menu" : "modal"}>
                        {children}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <div className="dim-screen" onClick={onCloseModal}/>
                <div className={drawAboveMenu ? "modal above-menu" : "modal"}>
                    <div className="card-default" style={{width:(width)?`${modalWidth}px`:undefined}}>
                        {children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

Modal.propTypes = {
    drawAboveMenu: PropTypes.bool,
    width: PropTypes.number,
    innerWidth: PropTypes.number,
    children: PropTypes.node.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onComponentWillUnmount: PropTypes.func,
    hideCard: PropTypes.bool
};

export default connect(mapStateToProps)(Modal);